import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Label,
  Input,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';

import { APIgetGroups } from '../../../../api/Group';

import SettingsItemTitle from './ItemTitle';

const SettingsItemTeams = ({
  settingKey,
  setting,
  disabled,
  handleChange,
}) => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    APIgetGroups({ all: true }).then((response) => {
      const { data } = response;
      if (data) {
        setTeams(data);
      }
      setLoading(false);
    });
  }, []);

  return (
    <>
      <Label for={`setting-${settingKey}`} className={classnames({ disabled })} disabled={disabled}>
        <SettingsItemTitle setting={setting} />
      </Label>
      <div className="input-inner">
        <ListGroup flush className="switch-list group-permissions-list files-permissions-list user-profile-groups-list">
          {teams.map(g => (
            <ListGroupItem key={g.uuid}>
              <Label for={`switchGroup-${g.uuid}`} className="switch">
                <div className="switch-details">
                  <span>
                    {g.name}
                  </span>
                </div>
                <div className="switch-control input-inner">
                  <Input
                    type="checkbox"
                    name="groupUploadFile"
                    id={`switchGroup-${g.uuid}`}
                    value="true"
                    defaultChecked={setting.value.includes(g.uuid)}
                    disabled={loading}
                    onChange={(e) => {
                      if (e.target.checked) {
                        handleChange({
                          target: { value: [...setting.value, g.uuid] },
                        });
                      } else {
                        handleChange({
                          target: { value: setting.value.filter(uuid => uuid !== g.uuid) },
                        });
                      }
                    }}
                  />
                  <i />
                </div>
              </Label>
            </ListGroupItem>
          ))}
        </ListGroup>
      </div>
    </>
  );
};

SettingsItemTeams.propTypes = {
  settingKey: PropTypes.string.isRequired,
  setting: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

SettingsItemTeams.defaultProps = {
  disabled: false,
};

export default SettingsItemTeams;
